import { ApiResponse, ApiError } from './types';

// 환경 변수에서 API URL 가져오기
const API_BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

/**
 * fetch API를 사용한 기본 클라이언트
 */
export async function fetchAPI<T>(endpoint: string): Promise<T> {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new ApiError(response.status, `HTTP ${response.status}: ${response.statusText}`);
    }

    const result: ApiResponse<T> = await response.json();

    if (!result.success) {
      throw new ApiError(response.status, result.message || 'API request failed');
    }

    return result.data;
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }

    // 네트워크 에러 또는 기타 에러
    throw new ApiError(0, error instanceof Error ? error.message : 'Network error');
  }
}

/**
 * 인증이 필요한 API 호출용 클라이언트
 */
export async function fetchAuthAPI<T>(endpoint: string): Promise<T> {
  try {
    const token = localStorage.getItem('adminToken');

    if (!token) {
      throw new ApiError(401, 'No authentication token found');
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new ApiError(response.status, `HTTP ${response.status}: ${response.statusText}`);
    }

    const result: ApiResponse<T> = await response.json();

    if (!result.success) {
      throw new ApiError(response.status, result.message || 'API request failed');
    }

    return result.data;
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }

    // 네트워크 에러 또는 기타 에러
    throw new ApiError(0, error instanceof Error ? error.message : 'Network error');
  }
}

/**
 * POST 요청
 */
export async function postAPI<T>(endpoint: string, body?: any): Promise<T> {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      throw new ApiError(response.status, `HTTP ${response.status}: ${response.statusText}`);
    }

    const result: ApiResponse<T> = await response.json();

    if (!result.success) {
      throw new ApiError(response.status, result.message || 'API request failed');
    }

    return result.data;
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }

    throw new ApiError(0, error instanceof Error ? error.message : 'Network error');
  }
}

/**
 * POST 요청 (인증 필요)
 */
export async function postAuthAPI<T>(endpoint: string, body?: any): Promise<T> {
  try {
    const token = localStorage.getItem('adminToken');

    if (!token) {
      throw new ApiError(401, 'No authentication token found');
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      throw new ApiError(response.status, `HTTP ${response.status}: ${response.statusText}`);
    }

    const result: ApiResponse<T> = await response.json();

    if (!result.success) {
      throw new ApiError(response.status, result.message || 'API request failed');
    }

    return result.data;
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }

    throw new ApiError(0, error instanceof Error ? error.message : 'Network error');
  }
}

/**
 * PUT 요청 (인증 필요)
 */
export async function putAuthAPI<T>(endpoint: string, body?: any): Promise<T> {
  try {
    const token = localStorage.getItem('adminToken');

    if (!token) {
      throw new ApiError(401, 'No authentication token found');
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      throw new ApiError(response.status, `HTTP ${response.status}: ${response.statusText}`);
    }

    const result: ApiResponse<T> = await response.json();

    if (!result.success) {
      throw new ApiError(response.status, result.message || 'API request failed');
    }

    return result.data;
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }

    throw new ApiError(0, error instanceof Error ? error.message : 'Network error');
  }
}

/**
 * DELETE 요청 (인증 필요)
 */
export async function deleteAuthAPI<T>(endpoint: string): Promise<T> {
  try {
    const token = localStorage.getItem('adminToken');

    if (!token) {
      throw new ApiError(401, 'No authentication token found');
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new ApiError(response.status, `HTTP ${response.status}: ${response.statusText}`);
    }

    const result: ApiResponse<T> = await response.json();

    if (!result.success) {
      throw new ApiError(response.status, result.message || 'API request failed');
    }

    return result.data;
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }

    throw new ApiError(0, error instanceof Error ? error.message : 'Network error');
  }
}
